import ReactGA from "react-ga4";
import { memberType } from "../types/member";
import { GAMeasurementID } from "../constants/analytics";

export const initGA = (): void => {
    ReactGA.initialize(GAMeasurementID);
};

/**
 * Set user properties in GA4
 * @param userData Member data from API
 */
export const setGAUserProperties = (userData: memberType): void => {
    ReactGA.set({
        user_id: userData.customer_id,
        user_properties: {
            maac_org_id: userData.maac_org_id,
            maac_bot_id: userData.maac_bot_id,
            shop_name: userData.shop_name,
            platform_type: userData.platform_type
        }
    });
};

/**
 * Track page view
 * @param path Page path
 */
export const trackPageView = (path: string): void => {
    ReactGA.send({ hitType: "pageview", page: path });
};

/**
 * Track event
 * @param category Event category
 * @param action Event action
 * @param label Event label (optional)
 * @param value Event value (optional)
 */
export const trackEvent = (
    category: string,
    action: string,
    label?: string,
    value?: number
): void => {
    ReactGA.event({
        category,
        action,
        label,
        value
    });
}; 